import axios from 'axios';

/**
 * Upload files to S3 via presigned URLs
 * @param {Function} uploadFileS3 - mutation trigger from useUploadFileS3Mutation
 * @param {string} userId - Current userId
 * @param {File[]} files - Array of File objects
 * @returns {Promise<{ success: boolean, data?: Array, message?: string }>}
 */
export async function uploadFiles(uploadFileS3, userId, files) {
  try {
    // 1. Prepare payload for backend
    const payload = {
      userId,
      files: files?.map((file) => ({
        filename: file.name,
        contentType: file.type
      }))
    };

    // 2. Request presigned upload URLs
    const { data: res } = await uploadFileS3(payload);

    if (!res.success) {
      return { success: false, message: res.message || 'Failed to get upload URLs' };
    }

    // 3. Upload each file to S3 using the presigned URL
    const uploadPromises = res.data.map(async (fileData, index) => {
      const file = files[index];
      await axios.put(fileData.uploadUrl, file, {
        headers: { 'Content-Type': file.type }
      });
      return {
        filename: fileData.filename,
        fileUrl: fileData.uploadUrl,
        awsFilename: fileData?.awsFilename,
        mimeType: file.type,
        size: file.size
      };
    });

    const uploadedFiles = await Promise.all(uploadPromises);

    return { success: true, data: uploadedFiles };
  } catch (error) {
    console.error('File upload failed:', error);
    return { success: false, message: error.message || 'Unexpected error occurred' };
  }
}
